import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DOCUMENTOS } from '../../../app.constants';
import { MessageUtil } from '../messages/messageUtil';

@Injectable()
export class DocumentosService {

  constructor(private httpClient: HttpClient, private toastrService: ToastrService) { }


  async downloandDocument(caminho: string, descricao: string) {


    try {
      const doc = await this.buscarDocumento(caminho, descricao);

    if (doc['size'] === 0) {
      this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO, '', { timeOut: 8000 })
      return;
    }

      this.handleFile(doc, descricao);
    } catch (error) {
      this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO, '', { timeOut: 8000 })
    }

  }


  buscarDocumento(idLocal: string, dsDocumento: string) {
    return this.httpClient.get(`${DOCUMENTOS}/download/${idLocal}/${dsDocumento}`, {
      responseType: 'blob' as 'json'
    })
      .toPromise();
  }


  async downloandDocumentPautas(caminho: string, ano: number, descricao: string) {


    try {
      const doc = await this.buscarDocumentoPautas(caminho, ano, descricao);

    if (doc['size'] === 0) {
      this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO, '', { timeOut: 8000 })
      return;
    }

      this.handleFile(doc, descricao);
    } catch (error) {
      this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO, '', { timeOut: 8000 })
    }

  }


  buscarDocumentoPautas(idLocal: string, ano: number, dsDocumento: string) {
    return this.httpClient.get(`${DOCUMENTOS}/download/pautas/${idLocal}/${ano}/${dsDocumento}`, {
      responseType: 'blob' as 'json'
    })
      .toPromise();
  }

  handleFile(res: any, fileName: string) {


    const file = new Blob([res], { type: 'application/pdf' });

    // IE
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(file, fileName);
      return;
    }
    const fileURL = URL.createObjectURL(file);

    window.name = fileName;

    window.open(fileURL);




    // const blob = window.URL.createObjectURL(file);

    // const link = document.createElement('a');
    // link.href = blob;
    // link.download = fileName;

    // // link.click();
    // link.dispatchEvent(new MouseEvent('click', {
    //   bubbles: true,
    //   cancelable: true,
    //   view: window
    // }));

    // setTimeout(() => { // firefox
    //   window.URL.revokeObjectURL(blob);
    //   link.remove();
    // }, 100);
  }



}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/services/documentos.service.ts